var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 36810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6168 9.29848L11.3401 4.49108L9.75475 5.962C9.75475 6.63169 9.30886 7.16983 8.75398 7.16983C8.19909 7.16983 7.7532 6.63169 7.7532 5.97396L8.14955 5.49561L7.00015 4.1084L5.85074 5.49561L6.24709 5.97396C6.24709 6.63169 5.8012 7.16983 5.24631 7.16983C4.69143 7.16983 4.24554 6.63169 4.24554 5.962L2.66016 4.50304L3.38349 9.31044H10.6168V9.29848ZM3.35376 9.8725H10.6862V9.58549H3.35376V9.8725Z",
    fill: "url(#paint0_linear_1522_9246)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1522_9246",
    x1: 7.00015,
    y1: 4.1084,
    x2: 7.00015,
    y2: 9.8725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2064FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B37F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.cd3e4ef0d1ab08493cfc9c81de8bcfc2.svg";
export { ForwardRef as ReactComponent };